<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h1 class="text-h4">Suchergebnisse</h1>
      <v-btn color="primary" href="reporting/reports/new">Neue Suche</v-btn>
    </div>

    <v-row v-if="reports.length > 0">
      <v-col v-for="index in sortedReportIndices" :key="index" cols="12" md="6" xl="4">
        <ReportCard v-model="reports[index]" @destroy="destroyReport" />
      </v-col>
    </v-row>

    <v-card v-else variant="tonal">
      <v-card-title>Keine Suchergebnisse vorhanden</v-card-title>
      <v-card-text>Starte eine neue Suche nach unbebauten Flächen.</v-card-text>
      <v-card-actions>
        <v-btn color="primary" href="reporting/reports/new">Nach unbebauten Flächen suchen</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup>
  import ReportCard from "../components/report/Card.vue";
  import { createReportsChannel } from "../services/reports-channel";
  import { ref, computed } from "vue";

  const reports = ref([]);
  const reportsChannel = createReportsChannel(updateReport);
  const sortedReportIndices = computed(() => {
    return reports.value
      .map((_, index) => index)
      .sort((a, b) => {
        const leftDate = new Date(reports.value[a].created_at);
        const rightDate = new Date(reports.value[b].created_at);
        return rightDate - leftDate;
      });
  });

  function updateReport(report) {
    const index = reports.value.findIndex(r => r.id === report.id);
    if (index < 0) {
      reports.value.push(report);
    } else {
      reports.value[index] = report;
    }
  }

  function destroyReport(report) {
    const index = reports.value.findIndex(r => r.id === report.id);
    if (index > -1) {
      reports.value.splice(index, 1)
    }
  }
</script>
